import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const AllClubs = () => {
  const url = apiConstants.AllClubs;
  return httpClient.get(url).then((result) => result.data);
};

const GetClub = (clubId) => {
  const url = apiConstants.GetClub;
  return httpClient.get(`${url}?clubId=${clubId}`).then((result) => result.data);
};

export { AllClubs, GetClub };
